import { render, staticRenderFns } from "./exerciseHeader.vue?vue&type=template&id=fabd7478&scoped=true"
import script from "./exerciseHeader.vue?vue&type=script&lang=js"
export * from "./exerciseHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fabd7478",
  null
  
)

export default component.exports